import {
  Check as CheckIcon,
  ContentCopy as CopyIcon,
} from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';

interface WaitingRoomLinkButtonProps {
  hasLink: boolean;
  isCopying?: boolean;
  copied?: boolean;
  variant?: 'light' | 'dark';
  onCopy?: () => void;
}

export function WaitingRoomLinkButton({
  hasLink,
  isCopying = false,
  copied = false,
  variant = 'light',
  onCopy,
}: WaitingRoomLinkButtonProps) {
  const isDark = variant === 'dark';
  const buttonSx = isDark
    ? {
        color: 'common.white',
        borderColor: 'rgba(255,255,255,0.28)',
        '&:hover': {
          borderColor: 'rgba(255,255,255,0.45)',
          bgcolor: 'rgba(255,255,255,0.06)',
        },
        '&.Mui-disabled': {
          color: 'rgba(255,255,255,0.45)',
          borderColor: 'rgba(255,255,255,0.16)',
        },
      }
    : {};

  return (
    <Button
      fullWidth
      size="small"
      variant="outlined"
      startIcon={
        isCopying ? (
          <CircularProgress size={14} color="inherit" />
        ) : copied ? (
          <CheckIcon fontSize="small" />
        ) : (
          <CopyIcon fontSize="small" />
        )
      }
      disabled={!hasLink || isCopying || copied || !onCopy}
      onClick={onCopy}
      sx={{ textTransform: 'none', ...buttonSx }}
    >
      {copied ? 'Copied' : 'Copy link'}
    </Button>
  );
}
